import Icon, { iconColor, iconTypes } from "../../common/components/Icon.jsx";

import ChainFilterComponent from "./ChainFilterComponent.jsx";
import DropDown from "../../common/components/DropDown.jsx";
import { Localization } from "../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import TextField from "../../common/components/TextField.jsx";

class SingleChainSearchBar extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            filterActive: false,
            expanded: false,
            searchString: "",
        };
        this.wrapperRef = React.createRef();

        this.hideFilter = this.hideFilter.bind(this);
        this.onClickFilter = this.onClickFilter.bind(this);
        this.onClickClearFilter = this.onClickClearFilter.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.onEdit = this.onEdit.bind(this);
    }

    UNSAFE_componentWillMount() {
        const {
            onEdit,
            filter,
        } = this.props;
        if (filter) {
            onEdit({
                onlyNews: false,
                productGroupId: null,
                supplierId: null,
                ...filter,
                searchString: "",
            });
        } else {
            this.props.onEdit({
                searchString: "",
            });
        }

        this.setState({
            searchString: "",
        });
    }

    hideFilter() {
        this.setState({filterActive: false});
        this.props.setDropDown(null);
    }
    onClickFilter() {
        const {
            localization,
            setDropDown,
            useSingleEpix,
            useMultiChain,
            useMultiEpix,
        } = this.props;
        if( this.state.filterActive ) {
            this.hideFilter();
        } else if( !this.props.disabled && !this.state.filterActive ) {
            this.props.setDropDown(
                <DropDown rect={this.wrapperRef.current.getBoundingClientRect()} style={{width:500, overflow:"visible"}} heightFixed={258} shiftLeft={true} below={true} setDropDown={setDropDown} onComponentWillUnmount={this.hideFilter}>
                    <ChainFilterComponent localization={localization} onEdit={this.onEdit} setDropDown={setDropDown} useSingleEpix={useSingleEpix} useMultiChain={useMultiChain} useMultiEpix={useMultiEpix}/>
                </DropDown>
            );

            this.setState({filterActive: true});
        }
    }

    onClickClearFilter() {
        this.onEdit({
            productStatus: null,
            invoiceGroupId: null,
            productGroupId: null,
            supplierId: null,
        });
    }

    handleClickOutside() {
        // Clear search
        this.setState({
            expanded: false,
        });
    }

    onEdit(change) {
        const {
            onEdit,
        } = this.props;

        onEdit({
            ...change,
        });

        if (change.searchString && this.state.expanded !== (change.searchString.length > 0) && change.searchString !== this.state.searchString) {
            this.setState({
                expanded: change.searchString ? change.searchString.length > 0 : this.state.expanded,
                ...change,
            });
        } else {
            this.setState({
                ...change,
            });
        }
    }

    render() {
        const {
            deviceType,
            disabled,
            localization,
            style,
            useFilter,
        } = this.props;

        const tinyDevice = deviceType == "sm" || deviceType == "xs";

        const isFilterSelected = this.state.productGroupId != null || this.state.supplierId != null || this.state.productStatus != null || this.state.invoiceGroupId != null;
        const isFilterActive = this.state.filterActive || isFilterSelected;

        return (
            <React.Fragment>
                <div className={"card-default"} style={{ zIndex: undefined, opacity: disabled ? 0.5 : 1.0, ...style }}>
                    <div className="search-wrapper" style={{ flexFlow: useFilter ? "row" : "column" }} onClick={this.onClickFilter}>
                        <TextField className="search-container" disabled={disabled} placeholder={localization.text("order", "searchForProducts")} iconType={iconTypes.search} isValid={true} source={this.state} property="searchString" onEdit={this.onEdit} usingSubmit={true} />
                        {useFilter && (
                            <div className={`search-button-filter ${isFilterActive ? "active" : ""} ${tinyDevice ? "tinyDevice" : "largeDevice"}`} ref={this.wrapperRef}>
                                <Icon type={iconTypes.filter} className={"search-button-filter-icon noselect"} color={isFilterActive ? iconColor.white : iconColor.dark} />
                                {!tinyDevice && (
                                    <div className={`search-button-filter-text noselect ${isFilterActive ? "active" : ""}`}>
                                        {localization.text("order", "filterResaults")}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

SingleChainSearchBar.propTypes = {
    deviceType: PropTypes.string.isRequired,
    localization: Localization.propTypes.isRequired,
    filter: PropTypes.object.isRequired,
    onEdit: PropTypes.func.isRequired,
    setDropDown: PropTypes.func.isRequired,
    //
    disabled: PropTypes.bool,
    style: PropTypes.object,
    useFilter: PropTypes.bool,
    useSingleEpix: PropTypes.bool.isRequired,
    useMultiChain: PropTypes.bool.isRequired,
    useMultiEpix: PropTypes.bool.isRequired,
};
SingleChainSearchBar.defaultProps = {
    disabled: false,
};

export default SingleChainSearchBar;
